import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d4bb641"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["href", "data-pswp-width", "data-pswp-height"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "gallery__placeholder"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "gallery__footer"
}
const _hoisted_7 = { class: "gallery__navigation-wrapper" }
const _hoisted_8 = ["src", "onMouseenter"]

import { computed, onMounted, ref } from 'vue'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'
import 'photoswipe/dist/photoswipe.css'
import icons from '@/shared/assets/icons/icons'
import { ProductImage } from '../model/types/product-carousel'
import { ProductCarouselMutations } from '../model/state/mutations'
import { useAppStore } from '@/shared/config/storeConfig/storeConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCarousel',
  props: {
    carouselId: null,
    productId: null
  },
  setup(__props: any) {

const props = __props as {
	carouselId: string,
	productId: string,
};



const store = useAppStore()
const displayItemCount = computed(() => store.state.productCarousel.displayItemCount)
const allowLeft = computed(() => store.state.productCarousel.allowLeft)
const allowRight = computed(() => store.state.productCarousel.allowRight)
const currentPosition = computed(() => store.state.productCarousel.currentPosition)
const currentImageIndex = computed<number>(() => store.state.productCarousel.currentImageIndex)
const isLoading = computed(() => store.state.productCarousel.isLoading)
const navigationIsShow = computed(() => images.value?.length > displayItemCount.value - 1)
const images = computed((): ProductImage[] => store.state.productCarousel.images)
const currentImage = computed<ProductImage | undefined>(() => store.getters['productCarousel/getCurrentImage'])
const lightbox = ref<PhotoSwipeLightbox | null>(null)
const printMode = computed(() => store.state.print.printing)

const getImageURL = (image: ProductImage) => `data:image/${image.type};base64,${image?.data}`

function selectImage(index) {
	store.commit('productCarousel/' + ProductCarouselMutations.SET_CURRENT_IMAGE_INDEX, index)
	store.dispatch('productCarousel/checkDirectionsIsAllowed')
}

function handleError(event) {
	event.target.src = ''
}

function initializeLightbox() {
	if (!lightbox.value) {
		lightbox.value = new PhotoSwipeLightbox({
			gallery: '#' + props.carouselId,
			children: 'a',
			initialZoomLevel: 'fit',
			padding: { top: 32, bottom: 32, left: 32, right: 32 },
			closeTitle: 'Закрыть',
			zoomTitle: 'Масштаб',
			arrowPrevTitle: 'Предыдущая',
			arrowNextTitle: 'Следующая',

			errorMsg: 'Фото не может быть загружено',
			pswpModule: PhotoSwipe
		})

		lightbox.value.init()
	}
}

const currentImageWidth = ref(50)
const currentImageHeight = ref(50)
const onMainImageMouseEnter = (e: { target: HTMLImageElement }) => {
	currentImageHeight.value = e.target.naturalHeight
	currentImageWidth.value = e.target.naturalWidth
}

function navigateToPrev() {
	store.dispatch('productCarousel/navigateToPrev')
}

function navigateToNext() {
	store.dispatch('productCarousel/navigateToNext', props.productId)
}

const translate = computed((): string => {
	return `transform: translateX(calc(${-currentPosition.value} * (var(--item-width) + var(--item-gap))));`
})

const getRotation = (image: ProductImage) => `rotate: -${image?.rotation || 0}deg`

const initializeImages = async () => {
	await store.dispatch('productCarousel/getNextProductImageById', {
		id: props.productId,
		count: 1,
		needLoading: true
	})

	await store.dispatch('productCarousel/getNextProductImageById', {
		id: props.productId,
		count: displayItemCount.value - 1,
		needLoading: true
	})
}

onMounted(async () => {
	await initializeImages()

	initializeLightbox()
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "gallery",
    id: props.carouselId,
    style: _normalizeStyle(`--item-count: ${_unref(displayItemCount)};`)
  }, [
    (_unref(images).length)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _unref(printMode) ? _ctx.$route.path : getImageURL(_unref(currentImage)),
          "data-pswp-width": currentImageWidth.value,
          "data-pswp-height": currentImageHeight.value,
          target: "_blank",
          rel: "noreferrer",
          class: "gallery__link",
          "aria-label": "Открыть фотогалерею"
        }, [
          _createElementVNode("img", {
            class: "gallery__main",
            src: getImageURL(_unref(currentImage)),
            alt: "Выбранное изображение",
            "aria-label": "Открыть фотогалерею",
            onMouseenter: onMainImageMouseEnter,
            style: _normalizeStyle(getRotation(_unref(currentImage)))
          }, null, 44, _hoisted_3)
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "svg",
            innerHTML: _unref(icons).imagePlaceholder
          }, null, 8, _hoisted_5)
        ])),
    (_unref(images)?.length)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_unref(navigationIsShow))
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                onClick: navigateToPrev,
                class: _normalizeClass(["material-icons-round gallery__navigation gallery__navigation--left", {
					'active': _unref(allowLeft)
				}])
              }, "chevron_left", 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              style: _normalizeStyle(_unref(translate)),
              class: "gallery__list"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(images), (image, i) => {
                return (_openBlock(), _createElementBlock("img", {
                  class: _normalizeClass(["gallery__item", {
		        'gallery__item--active': i === _unref(currentImageIndex)
		      }]),
                  key: image.data.slice(100, 116) + i,
                  src: getImageURL(image),
                  alt: "image.alt",
                  style: _normalizeStyle(getRotation(image)),
                  onMouseenter: ($event: any) => (selectImage(i)),
                  onError: handleError
                }, null, 46, _hoisted_8))
              }), 128))
            ], 4)
          ]),
          (_unref(navigationIsShow))
            ? (_openBlock(), _createElementBlock("i", {
                key: 1,
                onClick: navigateToNext,
                class: _normalizeClass(["material-icons-round gallery__navigation gallery__navigation--right", {
					'active': _unref(allowRight)
				}])
              }, "chevron_right", 2))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _unref(isLoading)]
        ])
      : _createCommentVNode("", true)
  ], 12, _hoisted_1)), [
    [_directive_loading, _unref(isLoading) && !_unref(images).length]
  ])
}
}

})